define('models/composer/forms/MultipleChoiceQuestionAnswer',[
    'lib/lodash4',
    'lib/knockout',
    'util/ObservableModel',
    'util/javaInteropConstants',
    'lib/knockout.validation'
], function (
    _,
    ko,
    ObservableModel,
    javaInteropConstants
) {
    'use strict';

    var MultipleChoiceQuestionAnswerModel = ObservableModel.extend({
        defaults: {
            type: "answerOption",
            text: '',
            value: 0,
            killAnswer: false
        }
    }, function multiChoiceAnswerModel_init() {
        var self = this;

        self.modelId = self.id || _.uniqueId("answer");
        var hasFakeId = false;
        if (!self.id) {
            self.id = self.modelId;
            hasFakeId = true;
        }

        self.index = ko.observable(-1);

        self.text = self.text.extend({trimmed: null}); //trim whitespace off the text

        //Setup knockout validation
        self.text.extend({required: true});
        self.value.extend({
            digit: true,
            required: true,
            max: javaInteropConstants.JAVA_MAX_INT
        });
        ko.validation.group(self);

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'multipleChoiceQuestionAnswer': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.unwrap = function (toIgnore, options) {
            toIgnore = toIgnore || {};
            options = options || {};
            var typeName = 'multipleChoiceQuestionAnswer';
            var ignore = [
                "modelId",
                "errors",
                "unwrap",
                "isValid",
                "isAnyMessageShown"
            ];
            if (options.ignoreFakeIds && hasFakeId) {
                ignore.push('id');
            }
            if (toIgnore instanceof Array) { // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else { // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []);
            }
            var data = ObservableModel.unwrap(self, ignore);
            return data;
        };

    });

    return MultipleChoiceQuestionAnswerModel;
});

